import { AddCircle as AddCircleIcon, PersonAdd as PersonAddIcon } from "@mui/icons-material";
import { Avatar, Box, IconButton } from "@mui/material";
import { ImageField, ImageInput } from "react-admin";
import { useWatch } from "react-hook-form";

import { avatarBadgeSize, avatarSize, color } from "../theme/designTokens";

type AvatarInputProps = {
  name: string;
  source?: string;
};

export const AvatarInput = ({ name, source }: AvatarInputProps) => {
  const avatar = useWatch({ name });

  const hasNewUpload = avatar?.rawFile;
  const showExistingAvatar = source && !hasNewUpload;
  const showPlaceholder = !hasNewUpload && !source;

  const firstName = useWatch({ name: "firstName" });
  const lastName = useWatch({ name: "lastName" });

  const initials = `${firstName?.[0] || ""}${lastName?.[0] || ""}`.toUpperCase();
  const nameExists = !!firstName || !!lastName;

  const avatarSx = { width: avatarSize.lg, height: avatarSize.lg, cursor: "pointer" };

  const shouldShowAvatar = showExistingAvatar || nameExists || showPlaceholder;

  const avatarContent = shouldShowAvatar ? (
    <Avatar src={showExistingAvatar ? source : undefined} sx={avatarSx}>
      {nameExists ? (
        initials
      ) : showPlaceholder ? (
        <PersonAddIcon sx={{ width: avatarBadgeSize.md, height: avatarBadgeSize.md }} />
      ) : null}
    </Avatar>
  ) : (
    <></>
  );

  const placeholder = avatarContent ? (
    <Box sx={{ position: "relative", display: "inline-block" }}>
      {avatarContent}
      <IconButton
        sx={{
          position: "absolute",
          left: "50%",
          bottom: 0,
          transform: "translate(-50%, 50%)",
          color: color.primary,
          backgroundColor: color.white,
          padding: 0,
          "&:hover": {
            color: color.hover,
            backgroundColor: color.white,
          },
        }}
      >
        <AddCircleIcon />
      </IconButton>
    </Box>
  ) : (
    <></>
  );

  return (
    <ImageInput
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        "& .MuiFormHelperText-root": {
          display: "none",
        },
        "& .RaFileInput-dropZone": {
          display: hasNewUpload ? "none" : "block",
          backgroundColor: "white",
        },
      }}
      source={name}
      label={<></>}
      accept={{ "image/*": [] }}
      placeholder={placeholder}
    >
      <ImageField
        source="src"
        title="title"
        sx={{
          "& .RaImageField-image": {
            borderRadius: "50%",
            width: avatarSize.lg,
            height: avatarSize.lg,
            objectFit: "cover",
          },
        }}
      />
    </ImageInput>
  );
};
